import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../../styled/flexbox.styled"

export const AccountBookFilterContainer = styled(FlexContainer)({
  padding: "4px",
  height: "100%",
  overflowY: "auto",
})
